module.exports = __webpack_public_path__ + "img/thumbnail_IndianRhinoceros_m_normal.23d162de.png";